"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.error.title': '激活失败',
    'activate.error.generic': '账户激活过程中发生错误',
    'activate.error.no_token': '未提供激活令牌',
    'activate.error.network': '发生网络错误',
    'activate.error.invalid_link': '无效的激活链接',
    'activate.error.invalid_link_description': '您点击的激活链接无效或已过期。请尝试重新注册或联系支持。',
};
